import React, { useEffect, useRef, useState } from 'react';
import { Eraser } from 'lucide-react';

/* Unterschriften-Feld (Maus/Touch/Stift). onChange liefert data:image/png;base64 oder null. */
export const SignaturPad = ({ onChange, label, clearLabel = 'Löschen', testid = 'signatur-pad' }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const leerRef = useRef(true);
  const [leer, setLeer] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const scale = window.devicePixelRatio || 1;
    const w = c.clientWidth, h = c.clientHeight;
    c.width = w * scale; c.height = h * scale;
    const ctx = c.getContext('2d');
    ctx.scale(scale, scale);
    ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#1B3A5C';
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  const start = (e) => {
    e.preventDefault();
    try { ref.current.setPointerCapture(e.pointerId); } catch { /* optional */ }
    drawing.current = true; last.current = pos(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = pos(e), ctx = ref.current.getContext('2d');
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p;
    if (leerRef.current) { leerRef.current = false; setLeer(false); }
  };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(leerRef.current ? null : ref.current.toDataURL('image/png')); };
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); leerRef.current = true; setLeer(true); onChange(null); };

  return (
    <div data-testid={testid}>
      {label && <div className="text-[10px] tracking-wider uppercase text-[#7a8a99] mb-1">{label}</div>}
      <div className="relative border-2 border-dashed border-[#b8893d]/60 bg-white rounded-sm">
        <canvas ref={ref} className="w-full h-40 touch-none cursor-crosshair block" onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} onPointerCancel={end} data-testid={`${testid}-canvas`} />
        <div className="absolute left-4 right-4 bottom-8 border-b border-[#1B3A5C]/30 pointer-events-none" />
        {leer && <div className="absolute inset-0 flex items-center justify-center text-sm text-[#9aa5b1] pointer-events-none">✎</div>}
        <button type="button" onClick={clear} className="absolute top-2 right-2 inline-flex items-center gap-1 text-[10px] tracking-wider uppercase text-[#7a8a99] hover:text-[#1B3A5C] bg-white/80 px-2 py-1" data-testid={`${testid}-clear`}><Eraser className="w-3 h-3" /> {clearLabel}</button>
      </div>
    </div>
  );
};
